import Navbar from "../components/landingPage/Navbar";
import Hero from "../components/landingPage/Hero";
import Stats from "../components/landingPage/Stats";
import Features from "../components/landingPage/Features";
import HowItWorks from "../components/landingPage/HowItWorks";
import ExploreCentres from "../components/landingPage/ExploreCentres";
import BuiltFor from "../components/landingPage/BuiltFor";
import CTA from "../components/landingPage/CTA";
import Footer from "../components/landingPage/Footer";
import MachineCategories from '../components/landingPage/MachineCategories.jsx'
import Expertsdata from '../components/landingPage/Expertsdata';
export default function Landing() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Stats />
      <Features />
      {/* <HowItWorks /> */}
      <MachineCategories />
      <ExploreCentres />
       <Expertsdata />
      
            
      {/* <BuiltFor /> */}
      <CTA />
      <Footer />
    </div>
  );
}